import React from 'react';
import { ClassNameMap } from '@mui/material';
import TrendingUpOutlinedIcon from '@mui/icons-material/TrendingUpOutlined';
import TrendingDownOutlinedIcon from '@mui/icons-material/TrendingDownOutlined';
import RemoveOutlinedIcon from '@mui/icons-material/RemoveOutlined';
import makeStyles from '@mui/styles/makeStyles';
import classNames from 'classnames';

type TrendsProp = {
  prevData: number;
  currentData: number;
  label: string;
  classes?: ClassNameMap;
};
const trendsStyles = makeStyles((theme) => ({
  icon: {
    marginLeft: theme.spacing(1)
  },
  upIcon: {
    color: theme.palette.success.main
  },
  downIcon: {
    color: theme.palette.error.main
  }
}));
export const InsightsTrends: React.FC<TrendsProp> = ({
  prevData,
  currentData,
  label,
  classes: overrideClasses
}: TrendsProp) => {
  const classes = trendsStyles({ classes: overrideClasses });
  if (currentData > prevData) {
    return (
      <TrendingUpOutlinedIcon
        className={classNames(classes.icon, classes.upIcon)}
        data-testid={`upOutlinedIcon-${label}`}
      />
    );
  } else if (currentData < prevData) {
    return (
      <TrendingDownOutlinedIcon
        className={classNames(classes.icon, classes.downIcon)}
        data-testid={`downOutlinedIcon-${label}`}
      />
    );
  } else
    return (
      <RemoveOutlinedIcon
        className={classes.icon}
        color="action"
        data-testid={`flatOutlinedIcon-${label}`}
      />
    );
};
